import { SensorsType } from '@/constants/sensorsBurying'
import { initSensorsInstance } from '@/hooks/use-sensors'
import { checkDeviceBrand, isWeixin } from '@/utils/device'

const installUrlPatterns = [
  /\.apk(?:[?#].*)?$/i,
  /\.ipa(?:[?#].*)?$/i,
  /apps\.apple\.com/i,
  /itunes\.apple\.com/i,
  /^itms-apps:\/\//i,
  /^itms-services:\/\//i,
  /^mimarket:\/\//i,
  /app\.mi\.com\/details/i,
  /appgallery\.huawei\.com/i,
]

export const isInstallUrl = (url?: string) => {
  try {
    if (!url) return false

    return installUrlPatterns.some(pattern => pattern.test(url))
  } catch {
    return false
  }
}

export const trackWechatInstallApp = (url?: string, forceTrack = false) => {
  try {
    if (!isWeixin() || (!forceTrack && !isInstallUrl(url))) return
    const search = new URLSearchParams(window.location.search)
    initSensorsInstance(sensors => {
      try {
        sensors.track(SensorsType.click_wechat_download_app, {
          ad_channel_code: search.get('adChannelCode') || localStorage.getItem('ad_channel_code') || '',
          user_behavior_id: localStorage.getItem('user_behavior_code') || '',
          is_source: 'H5',
          brand: checkDeviceBrand(),
          pagePath: window.location.pathname,
          content: url,
        })
      } catch {
        // 埋点失败不影响安装或跳转主流程
      }
    })
  } catch {
    // 埋点失败不影响安装或跳转主流程
  }
}
